import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

export const RiskPoint = styled.span`
  background-color: ${(p) => (p.active ? p.activeColor : p.backgroundColor)};
  height: 8px;
  width: 8px;
  border-radius: 2px;
  margin-right: 4px;
`;

export const RiskContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 0;
`;

function RiskLevel(props) {
  const theme = useTheme();
  const {
    risk,
    steps = 3,
    activeColor = theme.colors.secondary,
    backgroundColor = theme.colors.secondary80w,
    style,
  } = props;

  return (
    <RiskContainer style={style}>
      {[...Array(steps)].map((v, i) => (
        <RiskPoint
          activeColor={activeColor}
          backgroundColor={backgroundColor}
          key={i}
          active={i + 1 <= risk}
        />
      ))}
    </RiskContainer>
  );
}

RiskLevel.propTypes = {
  steps: PropTypes.number,
  risk: PropTypes.number,
  activeColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  style: PropTypes.object,
};

export default RiskLevel;
